import React, { Component } from 'react';
import { Map, Marker, Polygon, Polyline, GoogleApiWrapper, InfoWindow } from 'google-maps-react';
import myConfig from '../../configs/config';
import {
  MAP_VIEWPORT_SCOPES,
  applyViewportToGoogleMap,
  readLocalMapViewport,
  readViewportFromGoogleMap,
  resolveMapViewport,
  writeLocalMapViewport,
} from '../../utils/mapViewport';
import { LAND_PLOT_MAP_STYLE } from '../../utils/mapMeasurements';
import {
  getEquipmentPathPoints,
  resolveEquipmentMarkerPosition,
} from '../../containers/Dashboard/dashboardMapUtils';
import { offsetIfCoLocated } from '../../containers/Dashboard/dashboardTraceUtils';

import './Marker.css';

export class MapContainer extends Component {

  constructor(props) {    
    super(props)  
    this.ref = null;  
    this.viewportApplied = false;
    this.savedViewport = readLocalMapViewport(
      MAP_VIEWPORT_SCOPES.DASHBOARD,
      props.farm_id
    );
    this.state = {
      centroidLat: "",
      centroidLng: "",
      //- Azul - Vermelho - Amarelo - Laranja - Roxo - Magenta - Cyano - Ocre - Bordo - Petróleo - Azul naval - Quentão - Rosa           
      colors: ["#031AA5", "#DB0C03", "#F5B002", "#F36924", "#69029B", "#F100F7", "#23A1C6", "#857012", "#740224", "#0F565C", "#040244", "#AE4E46", "#DF1B5F"],
      activeMarker: {},
      selectedPlace: {},
      showPolygonInfoWindow : {},
      showPolygonInfo: false,
      zoom : false
    }    
    this.map = "";
    this.onMarkerClick = this.onMarkerClick.bind(this);    
  }
  
  handleSaveMapViewport = () => {
    if (!this.map || !this.map.map) return;
    const viewport = readViewportFromGoogleMap(this.map.map);
    writeLocalMapViewport(MAP_VIEWPORT_SCOPES.DASHBOARD, this.props.farm_id, viewport);
    this.savedViewport = viewport;
    this.viewportApplied = true;
    if (this.props.onSaveViewportExtra) {
      this.props.onSaveViewportExtra();
    }
  }

  triggerMapResize = () => {
    if (!this.map || !this.map.map || !this.props.google) return;
    window.setTimeout(() => {
      if (!this.map || !this.map.map || !this.props.google) return;
      this.props.google.maps.event.trigger(this.map.map, "resize");
    }, 80);
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.cleanMode === this.props.cleanMode &&
      prevProps.mapHeight === this.props.mapHeight
    ) {
      return;
    }
    this.triggerMapResize();
  }

  applySavedViewport(map) {
    if (this.viewportApplied || !this.savedViewport || !map) return;
    const viewport = this.savedViewport;
    const lat = Number(viewport.lat);
    const lng = Number(viewport.lng);
    const zoom = Number(viewport.zoom);
    const valid =
      Number.isFinite(lat) &&
      Number.isFinite(lng) &&
      Number.isFinite(zoom) &&
      Math.abs(lat) <= 90 &&
      Math.abs(lng) <= 180 &&
      zoom >= 3 &&
      zoom <= 21;
    if (!valid) {
      this.savedViewport = null;
      return;
    }
    applyViewportToGoogleMap(map, viewport);
    this.viewportApplied = true;
  }

  getFarmFallbackCenter() {
    const farm = this.props.farm || {};
    const centroid = farm.centroid || {};
    let lat = Number(centroid.lat);
    let lng = Number(centroid.lng);

    if (!Number.isFinite(lat) || !Number.isFinite(lng) || (lat === 0 && lng === 0)) {
      lat = Number(farm.latitude);
      lng = Number(farm.longitude);
    }

    if (!Number.isFinite(lat) || !Number.isFinite(lng) || (lat === 0 && lng === 0)) {
      const geo = farm.geo_coords;
      if (Array.isArray(geo) && geo.length >= 2) {
        lat = Number(geo[1]);
        lng = Number(geo[0]);
      } else if (geo && typeof geo === "object") {
        lat = Number(geo.lat != null ? geo.lat : geo.y);
        lng = Number(geo.lng != null ? geo.lng : geo.x);
      }
    }

    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      return { lat: -15.78, lng: -47.93 };
    }

    return { lat, lng };
  }

  getInitialViewport() {
    const farm = this.props.farm || {};
    const fallbackCenter = this.getFarmFallbackCenter();

    return resolveMapViewport({
      apiViewport: farm.map_viewport,
      localViewport: this.savedViewport,
      fallbackCenter,
      fallbackZoom: this.get_boundary(),
    });
  }

  emitMapCenter = () => {
    if (!this.map || !this.map.map || !this.props.onMapCenterChanged) return;
    const center = this.map.map.getCenter();
    if (!center) return;
    this.props.onMapCenterChanged({
      lat: center.lat(),
      lng: center.lng(),
    });
  };

  onMapReady = (_mapProps, map) => {
    if (!map || !this.props.google) return;
    const maps = this.props.google.maps;
    map.setMapTypeId(maps.MapTypeId.HYBRID);
    this.applySavedViewport(map);
    maps.event.trigger(map, "resize");
    this.emitMapCenter();
    if (this.props.onViewportActionsReady) {
      this.props.onViewportActionsReady({
        save: this.handleSaveMapViewport,
      });
    }
  }

  onMarkerClick(props, marker, e) {    
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true,
      showPolygonInfo : false        
    });
  }  
  
  onPolygonClick = (props,landplot,e) => {       
    //clica no elemento marker    
    this.setState({ showPolygonInfoWindow:{      
      render_marker : true,
      landplot : props.landplot,
      position: props.landplot.landplot_center,      
      markers: props.marker
    } });

    if(this.ref != null){         
        this.ref.props.onClick(this.ref.props,this.ref.marker)        
    }
    
  }  

  handleShowPolygonInfo = (props, marker, e) => {    
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: false,
      showPolygonInfo:true
    });
  }
  

  getRandomColor(i) {
    let color = this.state.colors[i];

    if (i >= this.state.colors.length) {
      color = this.state.colors[Math.round(Math.random(0, this.state.colors.length))];
    }

    return color;
  }


  render_markers() {
    let obj = this.props.equipments;
    let markers = [];
    const equipmentList = Object.values(obj || {});

    equipmentList.forEach((equip, index) => {
      const iconName = equip.traccar_ico || "tractor";
      let icon_url = "";
      try {
        icon_url += (equip.machine_status === "offline")
          ? require(`../../assets/traccar/offline/${iconName}.svg`)
          : require(`../../assets/traccar/online/${iconName}.svg`);
      } catch (error) {
        icon_url = (equip.machine_status === "offline")
          ? require("../../assets/traccar/offline/tractor.svg")
          : require("../../assets/traccar/online/tractor.svg");
      }

      const resolved = resolveEquipmentMarkerPosition(
        equip,
        this.props.farm,
        index,
        equipmentList.length
      );
      const coords = resolved.position;
      if (!coords) {
        return;
      }

      markers.push(<Marker
        key={`machine-${equip.id}`}
        icon={icon_url}
        title={equip.ident}
        markerKind="machine"
        speed={equip.speed}
        last_connection={equip.last_connection}
        operation={equip.operation}
        operator_label={equip.operator_label}
        label={{
          text: equip.ident,
          color: resolved.isFallback ? "#B0BEC5" : "white",
          fontWeight: "bold",
        }}
        extra_inf={equip.extra_inf}
        opacity={resolved.isFallback ? 0.72 : 1}
        onClick={this.onMarkerClick}
        position={coords}>
      </Marker>);
    });

    return markers;
  }

  getMachineMarkerPositions() {
    const equipmentList = Object.values(this.props.equipments || {});
    return equipmentList
      .map((equip, index) =>
        resolveEquipmentMarkerPosition(
          equip,
          this.props.farm,
          index,
          equipmentList.length
        ).position
      )
      .filter(Boolean);
  }

  render_operator_markers() {
    const operators = Object.values(this.props.operators || {});
    const machinePositions = this.getMachineMarkerPositions();
    return operators.map((operator) => {
      const lastKnown = operator.lastKnown;
      if (!lastKnown) return null;
      const position = offsetIfCoLocated(lastKnown, machinePositions);
      const online = operator.online;
      const icon_url = online
        ? require("../../assets/traccar/online/person.svg")
        : require("../../assets/traccar/offline/person.svg");
      return (
        <Marker
          key={`operator-${operator.id}`}
          icon={icon_url}
          title={operator.name}
          markerKind="operator"
          speed={operator.speed}
          last_connection={operator.last_connection}
          label={{
            text: operator.name,
            color: online ? "white" : "#B0BEC5",
            fontWeight: "bold",
          }}
          opacity={online ? 1 : 0.85}
          onClick={this.onMarkerClick}
          position={position}
        />
      );
    });
  }

  render_polygon_makers(){    
    if(this.state.showPolygonInfoWindow.render_marker === true){      
      return <Marker        
                    opacity={0}                                                
                    title={this.state.showPolygonInfoWindow.landplot.name}                   
                    ref={el=>this.ref = el}
                    onClick={this.handleShowPolygonInfo}
                    label={{ text: this.state.showPolygonInfoWindow.landplot.name, color: 'white', fontWeight: 'bold' }}
                    position={this.state.showPolygonInfoWindow.landplot.landplot_center}/>                                                                                                        
    }
  }

  render_info() {        
    if(this.state.showPolygonInfo === true){          
      return <InfoWindow marker={this.state.activeMarker} visible={true} onCloseclick={(e) => { this.setState({ showPolygonInfo: false }) }}>
          <div>
            <ul>
              <h5><b>Nome:</b> {this.state.showPolygonInfoWindow.landplot.name}</h5>
              <h5><b>Area:</b> {this.state.showPolygonInfoWindow.landplot.area_h2} ha</h5>
            </ul>
          </div>
      </InfoWindow>;         
    }else{            
      let extra_inf = "";
      
      let operation = this.state.activeMarker.operation !== "" ?
      <h5><b>Operação:</b> {this.state.selectedPlace.operation}</h5> : null

      const operatorLabel = this.state.selectedPlace.operator_label ? (
        <h5><b>Operador:</b> {this.state.selectedPlace.operator_label}</h5>
      ) : null;

      if (this.state.selectedPlace.markerKind === "operator") {
        return <InfoWindow
          marker={this.state.activeMarker}
          visible={true}>
          <div>
            <ul>
              <h5>{this.state.selectedPlace.title}</h5>
              <h5><b>Telemetria:</b> operador</h5>
              <h5><b>Velocidade:</b> {this.state.selectedPlace.speed}</h5>
              <h5><b>Última conexão:</b> {this.state.selectedPlace.last_connection}</h5>
            </ul>
          </div>
        </InfoWindow>
      }

      if (this.state.selectedPlace.extra_inf !== undefined) {
        this.state.selectedPlace.extra_inf.map((info) => {
          extra_inf = <h5><b>{info.label}:</b> {info.value}</h5>
        });
      }

      return <InfoWindow
        marker={this.state.activeMarker}
        visible={true}>
        <div>
          <ul>
            <h5>{this.state.selectedPlace.title}</h5>
            <h5><b>Velocidade:</b> {this.state.selectedPlace.speed}</h5>
            <h5><b>Última conexão:</b> {this.state.selectedPlace.last_connection}</h5>
            {operation}
            {operatorLabel}
            {extra_inf}
          </ul>
        </div>
      </InfoWindow>
    }
  }

  render_lines() {
    let i = 0;
    let colors = [];
    let lines = [];
    for (let target of Object.values(this.props.equipments)) {
      colors.push({ "equipment": target.ident, "color": this.getRandomColor(i) });

      const coords = getEquipmentPathPoints(target);
      if (!coords || coords.length < 2) {
        i++;
        continue;
      }

      lines.push(<Polyline
        key={target.id}
        path={coords}
        strokeColor={colors[i].color}
        strokeWeight={4} />)
      i++;
    }
    return lines;
  }

  render_operator_lines() {
    const lines = [];
    Object.values(this.props.operators || {}).forEach((operator) => {
      const coords = (operator.last_posi_point || []).filter(
        (point) => point && point.lat != null && point.lng != null
      );
      if (coords.length < 2) return;
      lines.push(
        <Polyline
          key={`operator-line-${operator.id}`}
          path={coords}
          strokeColor="#F5B002"
          strokeOpacity={0.9}
          strokeWeight={3}
        />
      );
    });
    return lines;
  }

  render_polygon() {
    if (this.props.landplot !== "") {
      return this.props.landplot.map(landplot => {
        let geometry = JSON.parse(landplot.geomap);
        let coords = geometry.coordinates[0].map(function (item) {
          return { lat: item[1], lng: item[0] };
        });

        return (
          <Polygon
            key={landplot.id}
            paths={coords}
            strokeColor={LAND_PLOT_MAP_STYLE.strokeColor}
            strokeWeight={LAND_PLOT_MAP_STYLE.strokeWeight}
            strokeOpacity={LAND_PLOT_MAP_STYLE.strokeOpacity}
            fillColor={LAND_PLOT_MAP_STYLE.fillColor}
            fillOpacity={LAND_PLOT_MAP_STYLE.fillOpacity}
            landplot={landplot}
            onClick={this.onPolygonClick}
          />
        )
      });
    }
  }

  get_boundary() {
    const GLOBE_WIDTH = 256;
    const farm = this.props.farm || {};
    if (farm.centroid && farm.centroid.angle > 0) {
      let zoom = (Math.round(Math.log(window.innerWidth * 360 / farm.centroid.angle / GLOBE_WIDTH) / Math.LN2) - 2); 
      return zoom > 16 ? 16 : zoom 
    } 
    else {
      return 14
    }
  }
  
  render_map() {
    let polygons = this.render_polygon();
    let polygon_marker = this.render_polygon_makers();    
    let markers = this.render_markers();
    let operatorMarkers = this.render_operator_markers();
    const initialViewport = this.getInitialViewport();
    let zoom =
      this.props.mapZoom !== 0 ? this.props.mapZoom : initialViewport.zoom;
    let lines = this.render_lines();
    let operatorLines = this.render_operator_lines();
    let info = this.render_info();    
    let lat = initialViewport.lat;
    let lng = initialViewport.lng;
    let markers_center = this.props.marker_center;
    let bounds = new this.props.google.maps.LatLngBounds();    
        
    if (markers_center.length > 0) {                  
      if (this.map !== "") {                        
        this.map.map.fitBounds(bounds.extend(markers_center[markers_center.length - 1]));
        this.map.map.setZoom(zoom);
      }
    }    

    return (      
      <Map google={this.props.google}        
        ref={(el) => this.map = el}       
        zoom={zoom}            
        initialCenter={{
          lat: lat,
          lng: lng
        }}
        style={{ width: "100%", height: "100%" }}
        containerStyle={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: "100%",
          height: "100%",
        }}
        mapType={"hybrid"}
        mapTypeControl={false}
        fullscreenControl={false}
        zoomControl={true}
        gestureHandling="greedy"
        onZoom_changed={(e)=>this.props.zoomChanged(e)}
        onDragend={this.emitMapCenter}
        onIdle={this.emitMapCenter}
        onReady={this.onMapReady}
      >        
        {polygons}
        {polygon_marker}
        {operatorLines}
        {lines}
        {markers}
        {operatorMarkers}
        {info}
      </Map>
    );
  }


  render() {
    let map = "";

    map = this.render_map()    

    return (
      <div className="dashboard-map-wrapper">
        {map}
      </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: (myConfig.GOOGLE_API_KEY),
  libraries:['drawing','places'],
  version: '3.64'
})(MapContainer)
